/* import __COLOCATED_TEMPLATE__ from './add-questions.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { TrackedArray } from 'tracked-built-ins';

interface AddQuestionsArgs {
  isOpen: boolean;
  onClose: () => void;
  onSave: (questions: string[]) => Promise<void>;
  questionQuota: number;
  questionLimit: number;
}

class QuestionInput {
  @tracked text = '';

  constructor(text = '') {
    this.text = text;
  }
}

export default class AddQuestions extends Component<AddQuestionsArgs> {
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;

  @tracked questions: TrackedArray<QuestionInput> = new TrackedArray([new QuestionInput()]);

  get questionsHaveContent() {
    return this.questions.some((q) => q.text.trim());
  }

  get modalTitle() {
    return this.intl.t('ai-agent.playground.add-manually');
  }

  @action updateQuestions(questions: TrackedArray<QuestionInput>) {
    this.questions = questions;
  }

  @action
  removeQuestion(index: number) {
    this.questions.splice(index, 1);
  }

  @action
  async save() {
    await this.args.onSave(this.questions.map((q) => q.text));
    this.onClose();
  }

  @action
  onClose() {
    this.questions = new TrackedArray([new QuestionInput()]);
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::AddQuestions': typeof AddQuestions;
  }
}
